/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Diamond = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 22L23 9.00857L17.5034 2L7.01855 2.00938L1 9.00859L12 22ZM12.0045 19.6733L12.0882 19.5745L15.677 9.75857L8.6499 9.75858L12.0045 19.6733ZM9.00365 8.25858L15.3783 8.25857L12.3315 3.50463L12.1643 3.50478L9.00365 8.25858ZM10.3619 3.50639L7.70754 3.50876L3.62322 8.25859L7.20238 8.25858L10.3619 3.50639ZM3.6005 9.75859L7.06637 9.75858L9.37311 16.5763L3.6005 9.75859ZM14.1121 3.50303L17.1599 8.25857L20.5055 8.25857L16.774 3.50065L14.1121 3.50303ZM20.3995 9.75857L17.2741 9.75857L14.8991 16.2548L20.3995 9.75857Z"
                        fill={color}
                    />
                </svg>
        );
    };
